<div>
    <div class="box">
      <button (click)="onClickIntersect()" class="circle-infobox-button" id="streetInfoTool" matTooltip="Activar herramienta street view" matTooltipPosition="left">
        <img *ngIf="this.toolInfoBoxService.isInfoBoxActive" [src]="'icon_info_box.svg' | findUrl" class="img-button">
        <img *ngIf="!this.toolInfoBoxService.isInfoBoxActive" [src]="'icon_info_box_gris.svg' | findUrl" class="img-button">
      </button>
    </div>
</div>